export default __webpack_public_path__ + "static/media/ic_sentiment_very_satisfied_48px.d9db9853.svg";